import SideBlockAds from "@components/Blocks/Container/SideBlockAds";
import Iframe from "@elements/Iframe/Iframe";
import { getGTMData } from "@helper/getMetaData";
import type { BHBasePageProps } from "@routes/BHBasePage";
import BHBasePage from "@routes/BHBasePage";
import { ResponseType, TRouteWithRedirect } from "@sphtech/web2-core/ssr";
import { PageAdTargetingTypeEnum } from "@typings/Ads.d";
import type { GADataProps } from "@typings/GA";

export function meta() {
  return [
    {
      title: "Kenali Kami, Berita - BeritaHarian.sg",
      slug: "/kenali-kami",
      description: "Berita - . Baca lebih lanjut di BeritaHarian.sg",
    },
  ];
}

export default function KenaliKami() {
  const uniqueSectionName = "kenali-kami";
  const pageAdTargetType = PageAdTargetingTypeEnum.LISTING;
  const basePageProps: BHBasePageProps = {
    uniqueSectionName: uniqueSectionName,
    pageAdTargetValue: pageAdTargetType,
  };

  return (
    <BHBasePage {...basePageProps}>
      <div className="max-w-screen-cxl m-auto flex flex-col lg:flex-row">
        <div className="flex lg:px-sm flex-col w-12/12 lg:w-8/12 w-full">
          <h1 className="flex text-lg font-semibold mt-0 mb-12">Kenali Kami</h1>
          <Iframe
            title="Kenali Kami"
            src="//www.youtube.com/embed/Sz4QGmXHL5I"
            width="w-full"
          />
          <p className="text-xs mt-4 mb-12">
            Berita Harian mula diterbitkan di Singapura pada 1 Julai 1957.
            Sebagai sebuah akhbar utama masyarakat Melayu/Islam, Berita Harian
            berperanan dalam menyampaikan maklumat dan berita secara tepat dan
            menyeluruh. Setelah lebih sedekad di alam siber, cyBerita melalui
            penjenamaan semula dan kini dikenali sebagai BeritaHarian.sg yang
            menawarkan kepelbagaian demi menepati cita rasa khalayak pembaca
            yang pelbagai. Berita Harian kini boleh didapati menerusi pelbagai
            wadah digital, termasuk tablet dan telefon bijak. Segalanya demi
            kemudahan pembaca, segalanya di hujung jari anda.
          </p>
        </div>
        <SideBlockAds
          pageAdTargetingProps={pageAdTargetType}
          adsSectionName={uniqueSectionName}
          adsOnly={true}
        />
      </div>
    </BHBasePage>
  );
}

export function loader(): Promise<TRouteWithRedirect<object | null, string>> {
  const gaData: GADataProps = {
    level2: "miscellaneous",
    title: "Kenali Kami",
    section: "miscellaneous",
    contentcat: "1",
    contenttype: "listing",
  };

  return Promise.resolve({
    type: ResponseType.SUCCESS,
    statusCode: 200,
    payload: null,
    cacheControlMaxAge: 300, // 5 minutes
    regenerateInterval: 172800, // 2 days
    gtm: getGTMData(gaData),
  });
}
